import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {loadOnInteractionOrIdle} from './load-on-interaction'

// MRT multi site
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../utils/site-config'
import {useBrand} from '../contexts/brand-context'

export function KlarnaScript() {
    const config = getConfig()
    const {site} = useMultiSite()
    const siteId = site?.id
    let clientId = getSiteEnvVarValue(config.app, 'KLARNA_CLIENT_ID', siteId)
    const environment = getSiteEnvVarValue(config.app, 'KLARNA_OSMSDK_ENV', siteId)
    const {brandId} = useBrand()
    const brandIdValue = brandId && brandId.toLowerCase() || 'garage'
    const siteIdLower = siteId && siteId.toLowerCase()

    if (siteIdLower === "dynamitegarageca" || siteIdLower === "dynamitegarageus") {
        if (brandIdValue === 'dynamite') {
            clientId = getSiteEnvVarValue(config.app, 'KLARNA_OSMSDK_CLIENT_ID_DYNAMITE', siteId)
        }

        if (brandIdValue === 'garage') {
            clientId = getSiteEnvVarValue(config.app, 'KLARNA_OSMSDK_CLIENT_ID_GARAGE', siteId)
        }
    }

    useEffect(() => {
        // Check if script is already loaded
        if (document.getElementById('klarna-script')) {
            return
        }

        // Defer Klarna loading until user interaction or idle
        // This improves TTI by not blocking the main thread on initial load
        const cleanup = loadOnInteractionOrIdle(() => {
            // Double-check in case it was loaded during the delay
            if (document.getElementById('klarna-script')) {
                return
            }

            const script = document.createElement('script')
            script.nonce = window.__CSP_NONCE__
            script.id = 'klarna-script'
            script.src =
                environment === 'playground'
                    ? 'https://js.playground.klarna.com/web-sdk/v1/klarna.js'
                    : 'https://js.klarna.com/web-sdk/v1/klarna.js'
            script.async = true
            script.setAttribute('data-environment', environment)
            script.setAttribute('data-client-id', clientId)

            script.onload = () => {
                window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                window.KlarnaOnsiteService.push({eventName: 'refresh-placements'})
            }

            document.head.appendChild(script)
        }, { timeout: 3000 })

        // Cleanup
        return () => {
            cleanup?.()
            const existingScript = document.getElementById('klarna-script')
            if (existingScript) {
                existingScript.remove()
            }
        }
    }, [])

    return null // Renders nothing
}
